import { restRequest } from "vrcore-dashboard/dist/utilities";
export const VRCORE_PROFILE_EDIT_SELECTED_USER_UID = "PROFILE_EDIT.SELECTED_USER_UID";
export const VRCORE_GET_USERS = restRequest("PROFILE_EDIT.GET_USERS");
export const VRCORE_PROFILE_EDIT_SELECTED_TAB = "PROFILE_EDIT.SELECTED_TAB";
export const VRCORE_POST_EDITED_USER = restRequest("PROFILE_EDIT.POST_EDITED_USER");
export const VRCORE_GET_QUALIFICATIONS = restRequest("PROFILE_EDIT.GET_QUALIFICATIONS");
export const VRCORE_UPLOAD_IMAGE = restRequest("PROFILE_EDIT.UPLOAD_IMAGE");
export const VRCORE_REMOVE_IMAGE = restRequest("PROFILE_EDIT.REMOVE_IMAGE");
